// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 759 ? "latex-linter-worker" : chunkId) + "." + {"225":"590ebf3f","759":"a73fd74c"}[chunkId] + ".chunk.js";
};